var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
/* eslint-disable no-console */
import { call, put, select } from 'redux-saga/effects';
import { batchActions } from 'redux-batched-actions';
import { getProductsData } from '../../../../selectors';
import { findRouteFromList } from '../../../../../utils/find-route-from-list';
import { loadAndInjectMenuProducts } from '../../../../../utils/load-and-inject';
import { setMenuAction, setProductsAction } from '../../../../actions';
import { getUpdatedMappedMenu } from '../get-updated-mapped-menu';
import { getUpdatedFullMenu } from '../get-updated-full-menu';
export function navigateByMenuProcess(_a) {
    var productsMenuItems, productItem, routeName, routeNameWasInjected, loadedItems, _b, injectedRouteName, loaded, extendedRouteName, extendedRouteNameWasInjected, updatedMappedMenu, updatedFullFlattenedMenu, error_1;
    var _c;
    var menuName = _a.menuName, router = _a.router, _d = _a.routeParams, routeParams = _d === void 0 ? {} : _d, loadModuleFunction = _a.loadModuleFunction, _e = _a.additionalParams, additionalParams = _e === void 0 ? {} : _e, notFoundRouteName = _a.notFoundRouteName, mappedMenuList = _a.mappedMenuList, fullFlattenedMenuList = _a.fullFlattenedMenuList, navigationErrorLogger = _a.navigationErrorLogger, externalPackages = _a.externalPackages;
    return __generator(this, function (_f) {
        switch (_f.label) {
            case 0: return [4 /*yield*/, select(getProductsData)];
            case 1:
                productsMenuItems = _f.sent();
                _f.label = 2;
            case 2:
                _f.trys.push([2, 5, , 6]);
                productItem = productsMenuItems.find(findRouteFromList({ menuName: menuName }));
                console.log('[navigateByMenuProcess]: externalPackages', externalPackages);
                console.log('[navigateByMenuProcess]: productItem', productItem);
                if (!productItem) {
                    console.error("Service ".concat(menuName, " was not found in navigateByMenuProcess"));
                    if (navigationErrorLogger) {
                        navigationErrorLogger({
                            menuName: menuName,
                            data: {
                                fullFlattenedMenuList: fullFlattenedMenuList,
                            },
                        });
                    }
                    router.navigate(notFoundRouteName);
                    return [2 /*return*/];
                }
                routeName = productItem.extendedRouteName || ((_c = productItem.config) === null || _c === void 0 ? void 0 : _c.routeName);
                if (routeName) {
                    routeNameWasInjected = router.buildState(routeName, routeParams || {});
                    console.log('[navigateByMenuProcess]: routeNameWasInjected', routeNameWasInjected);
                    if (routeNameWasInjected) {
                        console.log('params', {
                            routeName: routeName,
                            routeParams: routeParams,
                            additionalParams: additionalParams,
                        });
                        router.navigate(routeName, routeParams, additionalParams);
                        return [2 /*return*/];
                    }
                }
                return [4 /*yield*/, call(loadAndInjectMenuProducts, {
                        menuProducts: [productItem],
                        loadModuleFunction: loadModuleFunction,
                        router: router,
                        externalPackages: externalPackages,
                        disableFetchI18n: true,
                    })];
            case 3:
                loadedItems = _f.sent();
                _b = loadedItems[0], injectedRouteName = _b.routeName, loaded = _b.loaded;
                extendedRouteName = productItem.extendedRouteName;
                console.log('[navigateByMenuProcess]: extendedRouteName', extendedRouteName);
                if (extendedRouteName) {
                    extendedRouteNameWasInjected = router.buildState(extendedRouteName, routeParams || {});
                    console.log('[navigateByMenuProcess]: extendedRouteNameWasInjected', extendedRouteNameWasInjected);
                    if (extendedRouteNameWasInjected) {
                        console.log('params', {
                            extendedRouteName: extendedRouteName,
                            routeParams: routeParams,
                            additionalParams: additionalParams,
                        });
                        router.navigate(extendedRouteName, routeParams, additionalParams);
                        return [2 /*return*/];
                    }
                }
                updatedMappedMenu = getUpdatedMappedMenu({
                    loadedItems: loadedItems,
                    mappedMenu: mappedMenuList,
                });
                updatedFullFlattenedMenu = getUpdatedFullMenu({
                    loadedItems: loadedItems,
                    fullMenu: fullFlattenedMenuList,
                });
                console.log('updatedMappedMenu', updatedMappedMenu);
                console.log('updatedFullFlattenedMenu', updatedFullFlattenedMenu);
                return [4 /*yield*/, put(batchActions([
                        setMenuAction({ menu: updatedMappedMenu }),
                        setProductsAction({ products: updatedFullFlattenedMenu }),
                    ]))];
            case 4:
                _f.sent();
                console.log('[navigateByMenuProcess]: injectedRouteName and loaded', injectedRouteName, loaded);
                if (injectedRouteName && loaded) {
                    router.navigate(injectedRouteName, routeParams, additionalParams);
                }
                else {
                    console.error("Service ".concat(menuName, " can not be loaded in navigateByMenuProcess"));
                    router.navigate(notFoundRouteName);
                    if (navigationErrorLogger) {
                        navigationErrorLogger({
                            menuName: menuName,
                            data: {
                                fullFlattenedMenuList: fullFlattenedMenuList,
                            },
                        });
                    }
                }
                return [3 /*break*/, 6];
            case 5:
                error_1 = _f.sent();
                console.error('navigateByMenuProcess get an error', error_1);
                return [3 /*break*/, 6];
            case 6: return [2 /*return*/];
        }
    });
}
